import React from 'react';
import { Grid, Button, Icon, Popup, Image } from 'semantic-ui-react';
import Labels from '../../../../common/Labels';
import { dispatch } from '@rematch/core';
import { toastr } from 'react-redux-toastr';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
import wordImage from '../../../../../images/svg/Export/word.svg'

const ExportToWord = ({ selectedPracticeLibrary, currentPlaybookTemplate,isAuthor,isWorkspaceOwner,isContributor }) => {
    const fileUploaded = (data) => {

        if (data.target.files[0].name.split('.').pop() === 'docx') {

            var fileToLoad = data.target.files[0];
            var fileReader = new FileReader();

            fileReader.onload = async (fileLoadedEvent) => {
                if (fileLoadedEvent.target.result) {
                    await dispatch.lifeCycle.uploadPlaybookTemplate({
                        data: fileLoadedEvent.target.result,
                        organizationId: selectedPracticeLibrary.organizationId,
                        accountId: selectedPracticeLibrary.accountId,
                        packId: selectedPracticeLibrary._id,
                        fileName: fileToLoad.name
                    });
                    //   this.stopLoader();
                } else {
                    toastr.error('Message', 'Invalid File.');
                    // this.stopLoader();
                }
            };

            fileReader.readAsArrayBuffer(fileToLoad, "UTF-8");
            data.target.value = null;
        } else {
            toastr.error('Message', 'Invalid File.');
        }
    }
    const downloadTemplate = async () => {
        await dispatch.lifeCycle.getPlaybookTemplate(selectedPracticeLibrary._id);
    }
    const resetTemplate = () => {
        dispatch.lifeCycle.resetTemplate(selectedPracticeLibrary._id);
    }  
    return <div>
        <Grid className="bg-white" style={{ padding: "10px 5px 10px 15px" }}>
            <Grid.Row>
                <Grid.Column width={16}>
                    <Labels
                        text={<span><span > <Image style={{ height: "16px", margin: "0 5px 0 0", float: "left" }} src={wordImage} /></span>Word Document
                        {selectedPracticeLibrary && selectedPracticeLibrary.status === 0 && <span className={`float-right ${selectedPracticeLibrary.template ? "clr-blue cursor-pointer" : ''}`} style={{ fontFamily: "montserrat-normal" }} onClick={resetTemplate}>Reset</span>}</span>}
                    />
                </Grid.Column>
                <Grid.Column width={16}>
                    <Labels
                        name="Current Template"
                        text={selectedPracticeLibrary.template ? <EllipsisTooltip name={selectedPracticeLibrary.template.name} /> : " Default"} />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={16}>
                    {(selectedPracticeLibrary && selectedPracticeLibrary.status === 0 || (isAuthor || isWorkspaceOwner || isContributor)) &&
                    <div className="float-left" >
                        <Button
                            className="button-info "
                            onClick={downloadTemplate}
                        ><Icon name="download" />
                            <span style={{ fontWeight: "400" }}>Download</span></Button>
                    </div>
                    }
                    {selectedPracticeLibrary && selectedPracticeLibrary.status === 0 && <div className="float-right" >
                        <span className="clr-blue" style={{
                            width: "150px",
                            display: "inline-block",
                            verticalAlign: "bottom",
                            textAlign: "right",
                            margin: "0 5px"
                        }}>Need help in creating a word template ?</span>&nbsp;
                    <div className="file-upload-button-wrap float-right">
                            <label className="file-upload-button button-info" for="upload" style={{ opacity: 1 }} >
                                <Icon name='upload' /> Upload</label>
                            <input id="upload" type="file" onChange={(e) => fileUploaded(e)} accept=".docx" />
                        </div>
                    </div>}
                </Grid.Column>

            </Grid.Row>
        </Grid>
    </div>
}
export default ExportToWord;